module.exports = __webpack_public_path__ + "img/蒙版组 5.f48d4de8.png";